import _classCallCheck from "/drone/src/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/drone/src/node_modules/@babel/runtime/helpers/esm/createClass";
export var FilterBaseConditionType = /*#__PURE__*/function () {
  function FilterBaseConditionType(id) {
    var attributes = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

    _classCallCheck(this, FilterBaseConditionType);

    this.id = id;
    this.attributes = attributes;
  }

  _createClass(FilterBaseConditionType, [{
    key: "isValueEmpty",
    value: function isValueEmpty(condition, conditionValue) {
      var multiple = condition.multiple;

      var _ref = conditionValue || {},
          value = _ref.value;

      if (value === undefined || value === null) {
        return true;
      }

      return multiple ? !Array.isArray(value) || !value.length : value.toString() === '';
    }
  }, {
    key: "internalizeValue",
    value: function internalizeValue(externalValue) {
      return externalValue;
    }
  }, {
    key: "externalizeValue",
    value: function externalizeValue(internalValue) {
      return internalValue;
    }
  }, {
    key: "getAttributes",
    value: function getAttributes() {
      return this.attributes;
    }
  }, {
    key: "produceConditionValue",
    value: function produceConditionValue() {
      return {};
    }
  }]);

  return FilterBaseConditionType;
}();